import licenses from './licenses';

const tabs = {
    DeaTab: 'dea-tab',
    CdsTab: 'cds-tab',
  };

export default {
  licenses,
  tabs
}
